enum QuizFraudEnum {
  Blur = 1,
  ExitFullscreen = 2,
  Restart = 3,
  OutsideApp = 4,
}

export default QuizFraudEnum
